import { render } from "./whatsapp-followup-template-modal.vue?vue&type=template&id=4290c921"
import script from "./whatsapp-followup-template-modal.vue?vue&type=script&lang=js"
export * from "./whatsapp-followup-template-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__